import cn from 'classnames';
import type { ComponentProps } from 'react';
import { Avatar } from 'ui';
import { UserLink } from '../user-link';

type P = {
  avatar: Omit<ComponentProps<typeof Avatar>, 'children'>;
} & ComponentProps<typeof UserLink>;

// TODO: looks like this component should be in ui
const AvatarLink = ({ avatar, children, className, ...rest }: P) => (
  <UserLink className={cn('avatar-link', className)} effects={{ radius: false }} {...rest}>
    <Avatar {...avatar}>{children}</Avatar>
  </UserLink>
);

export default AvatarLink;
